module.exports = __webpack_public_path__ + "static/img/bg0.1cbfc94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/bg0.png
// module id = uJ9h
// module chunks = 1